const getPlayerPrimaryStats = (playerPosition: string, play) => {
  switch (playerPosition?.toLowerCase()) {
    case 'goalkeeper':
      return [
        {
          label: 'moment.statistics.saves',
          value: play?.playerSaves,
        },
        {
          label: 'moment.statistics.savesInTheBox',
          value: play?.playerSavesInTheBox,
        },
        {
          label: 'moment.statistics.punches',
          value: play?.playerPunches,
        },
      ];
    case 'defender':
      return [
        {
          label: 'moment.statistics.playerGoals',
          value: play?.playerGoals,
        },
        {
          label: 'moment.statistics.playerAssists',
          value: play?.playerAssists,
        },
        {
          label: 'moment.statistics.playerEffectiveClearance',
          value: play?.playerEffectiveClearance,
        },
      ];
    case 'midfielder':
      return [
        {
          label: 'moment.statistics.playerGoals',
          value: play?.playerGoals,
        },
        {
          label: 'moment.statistics.playerAssists',
          value: play?.playerAssists,
        },
        {
          label: 'moment.statistics.playerKeyPasses',
          value: play?.playerSuccessfulFinalThirdPasses,
        },
      ];
    case 'forward':
      return [
        {
          label: 'moment.statistics.playerGoals',
          value: play?.playerGoals,
        },
        {
          label: 'moment.statistics.playerAssists',
          value: play?.playerAssists,
        },
        {
          label: 'moment.statistics.playerShotsOnTarget',
          value: play?.playerShotsOnTarget,
        },
      ];
    default:
      return [];
  }
};
export const getAbsoluteValue = (value, mod, digits = 0) => {
  if (!Number(value) && !Number(mod)) {
    return 0;
  }
  const result = (value * 100) / mod;

  return digits
    ? Math.round(result * Math.pow(10, digits)) / Math.pow(10, digits)
    : Math.round(result);
};
export const getPlayerSecStatistics = (playerPosition: string, play) => {
  switch (playerPosition?.toLowerCase()) {
    case 'goalkeeper':
      return [
        {
          label: 'moment.statistics.playerTotalHighClaim',
          value: play?.playerTotalHighClaim,
        },
        {
          label: 'moment.statistics.playerAccuratePasses',
          value: `${play?.playerAccuratePasses} (${getAbsoluteValue(
            play?.playerAccuratePasses,
            play?.playerTotalPasses,
          )}%)`,
        },
      ];
    case 'defender':
      return [
        {
          label: 'moment.statistics.playerInterception',
          value: play?.playerInterception,
        },
        {
          label: 'moment.statistics.groundDuelsWon',
          value: `${play?.playerDuelsWon - play?.playerAerialDuelWon}/${
            play?.playerDuelsWon +
            play?.playerDuelsLost -
            play?.playerAerialDuelWon -
            play?.playerAerialDuelLost
          }(${getAbsoluteValue(
            play?.playerDuelsWon - play?.playerAerialDuelWon,
            play?.playerDuelsWon +
              play?.playerDuelsLost -
              play?.playerAerialDuelWon -
              play?.playerAerialDuelLost,
          )}%)`,
        },
        {
          label: 'moment.statistics.playerAerialDuelWon',
          value: `${play?.playerAerialDuelWon}/${
            play?.playerAerialDuelWon + play?.playerAerialDuelLost
          }(${getAbsoluteValue(
            play?.playerAerialDuelWon,
            play?.playerAerialDuelWon + play?.playerAerialDuelLost,
          )}%)`,
        },
        {
          label: 'moment.statistics.playerAccuratePasses',
          value: `${play?.playerAccuratePasses}(${getAbsoluteValue(
            play?.playerAccuratePasses,
            play?.playerTotalPasses,
          )}%)`,
        },
      ];
    case 'midfielder':
      return [
        {
          label: 'moment.statistics.playerAccuratePasses',
          value: `${play?.playerAccuratePasses}/${
            play?.playerTotalPasses
          } (${getAbsoluteValue(
            play?.playerAccuratePasses,
            play?.playerTotalPasses,
          )}%)`,
        },
        {
          label: 'moment.statistics.playerShotsOnTarget',
          value: `${play?.playerShotsOnTarget}/${
            play?.playerTotalShots
          } (${getAbsoluteValue(
            play?.playerShotsOnTarget,
            play?.playerTotalShots,
          )}%)`,
        },
        {
          label: 'moment.statistics.playerDuelsWon',
          value: play?.playerDuelsWon,
        },
      ];
    case 'forward':
      return [
        {
          label: 'moment.statistics.playerShotsOffTarget',
          value: play?.playerShotsOffTarget,
        },
        {
          label: 'moment.statistics.playerShotsBlocked',
          value: play?.playerShotsBlocked,
        },
        {
          label: 'moment.statistics.playerFouledFinalThird',
          value: play?.playerFouledFinalThird,
        },
      ];
    default:
      return [];
  }
};

export const getPlayerMatchStats = (play) => ({
  primary: getPlayerPrimaryStats(play?.playerPosition, play),
  secondary: getPlayerSecStatistics(play?.playerPosition, play),
});

export const getPlayStats = (play) => [
  {
    awayTeamValue: play?.awayTeamShotsOnTarget,
    homeTeamValue: play?.homeTeamShotsOnTarget,
    label: 'moment.statistics.shotsOnTarget',
  },
  {
    awayTeamValue: play?.awayTeamPossessionPercentage,
    homeTeamValue: play?.homeTeamPossessionPercentage,
    label: 'moment.statistics.possession',
  },
  {
    awayTeamValue: play?.awayTeamAccuratePasses,
    homeTeamValue: play?.homeTeamAccuratePasses,
    label: 'moment.statistics.passes',
  },
  {
    awayTeamValue: play?.awayTeamCornerTaken,
    homeTeamValue: play?.homeTeamCornerTaken,
    label: 'moment.statistics.cornerTaken',
  },
  {
    awayTeamValue: play?.awayTeamFreekickFoulLost,
    homeTeamValue: play?.homeTeamFreekickFoulLost,
    label: 'moment.statistics.freekickFoulLost',
  },
  {
    awayTeamValue: play?.awayTeamTotalYellowCard,
    homeTeamValue: play?.homeTeamTotalYellowCard,
    label: 'moment.statistics.totalYellowCard',
  },
  {
    awayTeamValue: play?.awayTeamTotalRedCard,
    homeTeamValue: play?.homeTeamTotalRedCard,
    label: 'moment.statistics.totalRedCard',
  },
];
